import React from "react";
import { View, Text, StyleSheet, Pressable } from "react-native";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";
const Tab = ({
  status,
  handleStatus,
}: {
  status: string;
  handleStatus: any;
}) => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-evenly",
        borderBottomWidth: 0.5,
        borderColor: "rgba(0,0,0,0.3)",
        paddingBottom: 10,
      }}
    >
      <Pressable
        style={[styles.status, status === "confirmed" && styles.activeStatus]}
        onPress={() => handleStatus("confirmed")}
      >
        <Text
          style={[
            status === "confirmed"
              ? GlobalStyles.tabTextDark
              : GlobalStyles.tabTextLight,
          ]}
        >
          Confirmed
        </Text>
      </Pressable>
      <Pressable
        style={[styles.status, status === "pending" && styles.activeStatus]}
        onPress={() => handleStatus("pending")}
      >
        <Text
          style={[
            status === "pending"
              ? GlobalStyles.tabTextDark
              : GlobalStyles.tabTextLight,
          ]}
        >
          Pending
        </Text>
      </Pressable>
      <Pressable
        style={[styles.status, status === "cancelled" && styles.activeStatus]}
        onPress={() => handleStatus("cancelled")}
      >
        <Text
          style={[
            status === "cancelled"
              ? GlobalStyles.tabTextDark
              : GlobalStyles.tabTextLight,
          ]}
        >
          Cancelled
        </Text>
      </Pressable>
    </View>
  );
};

export default Tab;

const styles = StyleSheet.create({
  status: {
    padding: 8,
    position: "relative",
    top: 10,
  },
  activeStatus: {
    borderBottomWidth: 1,
    borderColor: "#20232a",
  },
  activeTextStatus: {
    color: "black",
  },
});
